import { getFieldComponents, getFieldComponentTargets } from './componentClasses';

const INTERNAL_ATTRIBUTE_KEYS = new Set(['_events', '_handlers', 'uid', 'parent']);

export function getPlainHtmlAttributes(attributes) {
    if (attributes == null || typeof attributes != 'object') {
        return {};
    }

    if (typeof attributes.toJSON === 'function') {
        attributes = attributes.toJSON();
    }

    const result = {};
    Object.keys(attributes || {}).forEach(name => {
        const value = attributes[name];
        if (!INTERNAL_ATTRIBUTE_KEYS.has(name) && value != null && String(value).trim() != '') {
            result[name] = String(value);
        }
    });
    return result;
}

export function isSafeHtmlAttributeName(name) {
    return /^[A-Za-z][A-Za-z0-9\-_:]*$/.test(name) && !/^on/i.test(name);
}

export function hasComponentHtmlAttributes(item) {
    if (Object.keys(getPlainHtmlAttributes(item != null ? item.HtmlAttributes : null)).length > 0) {
        return true;
    }

    const componentAttributes = item != null && item.CtlProps != null ? item.CtlProps.ComponentHtmlAttributes : null;
    return componentAttributes != null && Object.keys(componentAttributes).some(componentId =>
        Object.keys(getPlainHtmlAttributes(componentAttributes[componentId])).length > 0);
}

export function applyFieldComponentHtmlAttributes(item) {
    if (item == null || item.CtlProps == null || item.CtlProps.ComponentHtmlAttributes == null) {
        return;
    }

    const componentMap = new Map(getFieldComponents(item).map(component => [component.id, component]));
    Object.keys(item.CtlProps.ComponentHtmlAttributes).forEach(componentId => {
        const component = componentMap.get(componentId);
        const attributes = getPlainHtmlAttributes(item.CtlProps.ComponentHtmlAttributes[componentId]);
        if (component == null || Object.keys(attributes).length == 0) {
            return;
        }

        const resolved = getFieldComponentTargets(item, component);
        if (resolved.widget != null && !resolved.widget._xpComponentHtmlAttributesBound) {
            resolved.widget._xpComponentHtmlAttributesBound = true;
            resolved.widget.bind('dataBound', () => applyFieldComponentHtmlAttributes(item));
            resolved.widget.bind('open', () => applyFieldComponentHtmlAttributes(item));
        }

        resolved.targets.forEach(target => {
            Object.keys(attributes).forEach(name => {
                if (isSafeHtmlAttributeName(name)) {
                    target.setAttribute(name, attributes[name]);
                }
            });
        });
    });
}
